export function twitchEmbedUrl(stream, hostname) {
  try {
    const url = new URL(stream.url);
    if (!["twitch.tv", "www.twitch.tv"].includes(url.hostname.toLowerCase())) return "";
    const channel = url.pathname.split("/").filter(Boolean)[0] || "";
    if (!/^[a-zA-Z0-9_]+$/.test(channel)) return "";
    return `https://player.twitch.tv/?channel=${encodeURIComponent(channel)}&parent=${encodeURIComponent(hostname)}&muted=false`;
  } catch {
    return "";
  }
}
